import { fit, getViewRect, type Rect } from "./getViewableRect"

/**
 * "Glues" an element to the footer, so it maintains a constant distance from it.
 */
export class FooterGlue {
    element: HTMLElement
    spacing: number
    constructor(element: HTMLElement, footerTop: number) {
        this.element = element
        this.updateBounds(footerTop)
        document.addEventListener("footerchange", (event: CustomEvent) => {
            this.onfooterchange(event)
        })
    }

    updateBounds(footerTop: number): void {
        const initialBottom = parseFloat(
            this.element.style.bottom === ""
                ? window.getComputedStyle(this.element).bottom
                : this.element.style.bottom
        )
        this.spacing = initialBottom - (window.innerHeight - footerTop)
    }

    onfooterchange(event: CustomEvent): void {
        const footerTop = window.innerHeight - event.detail
        this.element.style.bottom = `${this.spacing + footerTop}px`
    }

    // TODO: Remove if the OSM page bug where the page starts too tall and is resized is fixed
    fixOSMPage(): void {
        const bottom = window.innerHeight * 0.5 - 245
        this.element.style.bottom = `${bottom + 500}px`
        this.updateBounds(bottom)
    }
}

/**
 * Turns an element into a footer spacer, with the same height as the footer relative to the bottom of the page
 */
export class FooterSpacer {
    element: HTMLElement
    /**
     *
     * @param element Div that will take on the dimensions of the footer
     */
    constructor(element: HTMLElement) {
        this.element = element
        document.addEventListener("footerchange", (event: CustomEvent) => {
            this.onfooterchange(event)
        })
    }

    onfooterchange(event: CustomEvent): void {
        this.element.style.height = `${window.innerHeight - event.detail}px`
    }
}

function debugDrawRect(rect: Rect): void {
    let el = document.querySelector<HTMLDivElement>(".debug_rect")
    if (el === null) {
        el = document.createElement("div")
        document.body.append(el)
    }
    el.classList.add("debug_rect")
    el.style.pointerEvents = "none"
    el.style.backgroundColor = "rgba(255, 255, 0, 0.2)"
    el.style.zIndex = "1000000000000000"
    fit(el, rect)
}

export function dispatchFooterChangeEvent(): void {
    const rect = getViewRect()
    // debugDrawRect(rect)
    const event = new CustomEvent("footerchange", { detail: rect.bottom })
    document.dispatchEvent(event)
}

// Replace the onclick of the footer expand and collapse button
// with one that sends out footerchange events on progress
export function injectFooterChangeEventOnProgress(): void {
    function raiseFooterPopup(): void {
        if (window.innerWidth < 768) {
            $(".footer").hide()
            $(".footer-popup").animate(
                { height: "350px" },
                {
                    duration: 400,
                    progress: dispatchFooterChangeEvent,
                    complete: dispatchFooterChangeEvent,
                }
            )
        } else {
            $(".footer").hide()
            $(".footer-popup").animate(
                { height: "222px" },
                {
                    duration: 400,
                    progress: dispatchFooterChangeEvent,
                    complete: dispatchFooterChangeEvent,
                }
            )
        }
    }

    function lowerFooterPopup(): void {
        $(".footer").show()
        $(".footer-popup").animate(
            { height: "0" },
            {
                duration: 400,
                progress: dispatchFooterChangeEvent,
                complete: dispatchFooterChangeEvent,
            }
        )
    }

    // Swap the onclick to something that suits my needs
    // This is aggressive
    const popupOpenButton = document.querySelector<HTMLElement>(
        ".frame-6346517.nonselectable"
    )
    if (popupOpenButton === null) {
        throw new ReferenceError("No popup open button found")
    }
    popupOpenButton.setAttribute("onclick", "")
    popupOpenButton.onclick = raiseFooterPopup
    const popupCloseButton = document.querySelector<HTMLElement>(
        ".frame-6346498.pointer"
    )
    if (popupCloseButton === null) {
        throw new ReferenceError("No popup close button found")
    }
    popupCloseButton.setAttribute("onclick", "")
    popupCloseButton.onclick = lowerFooterPopup
}

export function watchForUIResizing(): void {
    const header = document.querySelector<HTMLElement>(".site-header-menu-bar") as HTMLElement

    // Header does not exit in Mobile App
    if (header){
        const observer = new ResizeObserver((entries, observer) => {
            dispatchFooterChangeEvent()
        })
        observer.observe(header)
    }
}
